import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../../components/shared/layout"
import SEO from "../../components/SEO/SEOPage"
import Img from "gatsby-image"
import styled from "@emotion/styled"
import {
  wrapper,
  color,
  featuredWrapper,
  noFeaturedWrapper,
  breakpoints,
  ContentStyles,
  ContentStylesExt,
} from "../../utils/style"
import Breadcrumbs from "../../components/shared/Breadcrumbs"
import GetWindowWidth from "../../components/shared/GetWindowWidth"
import PromoBlock from "../../components/Content/PromoBlock"
import GameProvidersNew from "../../components/Content/GameProvidersNew"
import ContactBlock from "../../components/Content/ContactBlock"
import BlogPosts from "../../components/Content/BlogPosts"
import EntranceLinksApp from "../../components/Content/Home/EntranceLinksApp"
import Star from "../../icons/svg/Star"

const WrapperDesktop = styled("div")`
  ${wrapper}
  .subtitle-text {
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      margin-right: 10px;
    }
  }
`

const FeaturedWrapper = styled("div")`
  ${featuredWrapper};
  position: relative;
  overflow: hidden;
  border: 4px solid ${color.red};
  border-radius: 8px;
  background: ${color.transparentDarkRed6};
  box-shadow: 0 0 48px rgba(142, 0, 0, 0.6);
  filter: drop-shadow(0px 0px 48px rgba(142, 0, 0, 0.6));
  .gatsby-image-wrapper {
    border-radius: 8px;
    z-index: 1;
    &::after {
      content: "";
      width: 100%;
      height: 100%;
      background: rgba(104, 0, 0, 0.3);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      border-radius: 8px;
      z-index: 2;
    }
  }
  h1 {
    font-size: 1.8rem;
    line-height: 2.3rem;
    text-shadow: ${color.goldTextShadow};
    margin: 0 auto 20px;
  }
  .top-wrap {
    max-width: 60%;
    position: absolute;
    top: 15%;
    left: 32px;
    right: 32px;
    z-index: 3;
  }
  .subtitle {
    font-size: 16px;
    line-height: 24px;
    white-space: pre-wrap;
  }
  .register-button {
    margin: 20px 0;
  }
  @media (max-width: ${breakpoints.md}) {
    .top-wrap {
      max-width: 90%;
    }
    h1 {
      font-size: 26px;
      line-height: 32px;
      margin: 0 0 16px;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .top-wrap {
      position: initial;
      max-width: 100%;
      padding: 10px 16px;
      .button {
        width: 100%;
      }
    }
    h1 {
      font-size: 26px;
      line-height: 32px;
      margin: 0 0 16px;
    }
  }
  @media (max-width: ${breakpoints.xs}) {
    h1 {
      font-size: 24px;
      line-height: 30px;
      margin: 0;
    }
  }
`

const NoFeaturedWrapper = styled("div")`
  ${noFeaturedWrapper};
  h1 {
    font-size: 1.8rem;
    line-height: 2.3rem;
  }
  .register-button {
    margin: 20px 0;
  }
  @media (max-width: ${breakpoints.sm}) {
    h1 {
      font-size: 24px;
      line-height: 32px;
    }
    .register-button {
      width: 100%;
    }
  }
`

const ContentWrapper = styled("div")`
  ${wrapper};
  ${ContentStyles};
  ${ContentStylesExt};
  padding: 0;
  @media (max-width: ${breakpoints.md}) {
  }
`

const PageTemplate = ({ data, pageContext }) => {
  const windowWidth = GetWindowWidth()
  const isDesktop = windowWidth > 600
  const homePageNode = data.allWordpressPage.edges[0].node
  const currentPage = data.wordpressPage
  const breadcrumbs = pageContext.breadcrumbs
  const page_title = pageContext.page_title
  const page_subtitle = currentPage.acf.top_subtitle
  const featuredMedia = currentPage.featured_media
  const metaTitle =
    currentPage.yoast_meta && currentPage.yoast_meta.yoast_wpseo_title
      ? currentPage.yoast_meta.yoast_wpseo_title
      : currentPage.title + "- " + process.env.OWNER
  const metaDesc =
    currentPage.yoast_meta && currentPage.yoast_meta.yoast_wpseo_metadesc
      ? currentPage.yoast_meta.yoast_wpseo_metadesc
      : ""
  const entranceLinksApp = homePageNode.acf.entrance_links_app
  const socialImage = currentPage.featured_media?.localFile?.publicURL

  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDesc}
        pathname={currentPage.path}
        breadcrumbs={breadcrumbs}
        socialImage={socialImage}
      />
      <WrapperDesktop>
        <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title} />
        {featuredMedia &&
        featuredMedia.localFile &&
        featuredMedia.localFile.childImageSharp &&
        featuredMedia.localFile.childImageSharp.fluid ? (
          <FeaturedWrapper>
            {isDesktop && (
              <Img
                fluid={featuredMedia.localFile.childImageSharp.fluid}
                alt={
                  currentPage.featured_media.alt_text
                    ? currentPage.featured_media.alt_text
                    : page_title
                }
                fadeIn={false}
                loading="eager"
              />
            )}
            <div className="top-wrap">
              <h1
                className="h1 rich-design"
                dangerouslySetInnerHTML={{ __html: page_title }}
              />
              {page_subtitle && (
                <span
                  className="subtitle"
                  dangerouslySetInnerHTML={{ __html: page_subtitle }}
                />
              )}
              {page_subtitle && (
                <div>
                  <Link
                    to={"/register/"}
                    className="button register-button transparent-button-gold"
                  >
                    คลิกเลย
                  </Link>
                </div>
              )}
            </div>
          </FeaturedWrapper>
        ) : (
          <NoFeaturedWrapper>
            <h1 dangerouslySetInnerHTML={{ __html: page_title }} />
            {page_subtitle && (
              <span dangerouslySetInnerHTML={{ __html: page_subtitle }} />
            )}
            {page_subtitle && (
              <div>
                <Link
                  to={"/register/"}
                  className="button register-button transparent-button-gold"
                >
                  คลิกเลย
                </Link>
              </div>
            )}
          </NoFeaturedWrapper>
        )}

        <ContactBlock />

        <h2 className="h1 subtitle-text rich-design with-icon a-center">
          <Star />
          <span>ขั้นตอนการดาวน์โหลดและติดตั้งโปรแกรม Casino Royal1688</span>
        </h2>

        <EntranceLinksApp gallery={entranceLinksApp} />

        <ContentWrapper>
          <div dangerouslySetInnerHTML={{ __html: currentPage.content }} />
        </ContentWrapper>
      </WrapperDesktop>

      <WrapperDesktop>
        <PromoBlock />
      </WrapperDesktop>

      <GameProvidersNew />

      <WrapperDesktop>
        <BlogPosts />
      </WrapperDesktop>
    </Layout>
  )
}

export default PageTemplate

export const pageQuery = graphql`
  query($id: String!) {
    wordpressPage(id: { eq: $id }) {
      wordpress_id
      title
      content
      date(formatString: "MMMM DD, YYYY")
      path
      yoast_meta {
        yoast_wpseo_title
        yoast_wpseo_metadesc
      }
      acf {
        page_template
        top_subtitle
      }
      featured_media {
        alt_text
        localFile {
          publicURL
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    }
    allWordpressPage(filter: { slug: { eq: "home-page" } }) {
      edges {
        node {
          acf {
            entrance_links_app {
              alt_text
              title
              path
              acf {
                slide_url
                slide_title
                slide_description
              }
              localFile {
                childImageSharp {
                  fluid(maxWidth: 198) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
